import { _ } from "../../../core/polyglot/polyglot.js";
import { formatCurrency } from "../../../core/helpers/currency-formatting-util.js";
import { Widget } from "@foretagsplatsen/widgetjs";
import keyFigureHighchartsOptions from "../../../models/keyFigure/rendering/keyFigureHighchartsOptions.js";

/**
 * Render key budget values in colored tiles.
 *
 * @param {Budget} spec.budget - Budget the values are taken from.
 */
export default class BudgetValuesPreviewWidget extends Widget {
	constructor({ budget }) {
		super(...arguments);

		this._budget = budget;
		this._chartOfAccounts = null;

		this._incomeColor = keyFigureHighchartsOptions.Income.color;
		this._costsColor = keyFigureHighchartsOptions.Cost.color;
		this._profitColor = keyFigureHighchartsOptions.Profit.color;
	}

	setBudget(budget) {
		this._budget = budget;
		this.update();
	}

	setChartOfAccounts(chartOfAccounts) {
		this._chartOfAccounts = chartOfAccounts;
		this.update();
	}

	renderContentOn(html) {
		html.div({ klass: "budget-values-preview" }, (html) => {
			if (!this._budget || !this._chartOfAccounts) {
				return;
			}
			this._renderValueTilesOn(html);
		});
	}

	_renderValueTilesOn(html) {
		html.render(
			[
				{
					value:
						0 -
						this._budget.computeTotalIncome(this._chartOfAccounts),
					color: this._incomeColor,
					legend: _("Income"),
					dataTestName: "income",
				},
				{
					value: this._budget.computeTotalCosts(
						this._chartOfAccounts,
					),
					color: this._costsColor,
					legend: _("Costs"),
					dataTestName: "costs",
				},
				{
					value: 0 - this._budget.computePeriodSum(),
					color: this._profitColor,
					legend: _("Profit"),
					dataTestName: "profit",
				},
			].map(this._valueTileRenderer.bind(this)),
		);
	}

	_valueTileRenderer({ value, legend, color, dataTestName }) {
		return (html) => {
			html.div(
				{
					klass: "value-preview",
					style: `background: ${color}`,
					"data-test": dataTestName,
				},
				html.div({ klass: "legend" }, legend),
				html.div({ klass: "value" }, formatCurrency(value)),
			);
		};
	}
}
